module.exports = __webpack_public_path__ + "e0485df818c9e7b609daf45c92cdde26.png";